import { render, staticRenderFns } from "./ContentsDetail.vue?vue&type=template&id=3a690fae&scoped=true&"
import script from "./ContentsDetail.vue?vue&type=script&lang=js&"
export * from "./ContentsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ContentsDetail.vue?vue&type=style&index=0&id=3a690fae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a690fae",
  null
  
)

export default component.exports